import { RootState } from "../../reducers";

export const pendingPollsSelector = (state: RootState): string[] =>
  state.polling.pendingPolls;
